export default __webpack_public_path__ + "static/mclaren1-ae7cc920c65c66ae83a553acecc52aa3.jpg";